import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "pp-draw-numbers-rychla-6",
  "data-test": "results-regular"
}
const _hoisted_2 = { class: "pp-draw-numbers-rychla-6__main-game" }
const _hoisted_3 = {
  key: 0,
  class: "pp-draw-numbers-rychla-6__group-title"
}
const _hoisted_4 = {
  key: 1,
  class: "pp-draw-numbers-rychla-6__group-title pp-draw-numbers-rychla-6__group-title--last"
}
const _hoisted_5 = { class: "pp-draw-numbers-rychla-6__container" }
const _hoisted_6 = { class: "pp-draw-numbers-rychla-6__sub-game" }
const _hoisted_7 = { class: "pp-draw-numbers-rychla-6__ratio" }
const _hoisted_8 = { class: "pp-draw-numbers-rychla-6__ratio-titles" }
const _hoisted_9 = { class: "pp-draw-numbers-rychla-6__ratio-value" }
const _hoisted_10 = { class: "pp-draw-numbers-rychla-6__ratio-value" }
const _hoisted_11 = { class: "pp-draw-numbers-rychla-6__ratio-beans" }
const _hoisted_12 = { class: "pp-draw-numbers-rychla-6__sub-game" }
const _hoisted_13 = { class: "pp-draw-numbers-rychla-6__ratio" }
const _hoisted_14 = { class: "pp-draw-numbers-rychla-6__ratio-titles" }
const _hoisted_15 = { class: "pp-draw-numbers-rychla-6__ratio-value" }
const _hoisted_16 = { class: "pp-draw-numbers-rychla-6__ratio-value" }
const _hoisted_17 = { class: "pp-draw-numbers-rychla-6__ratio-beans" }

import { DrawNumbers } from "@/lotteries/services/model/draw-numbers";
import { computed } from "vue";

const DRAWN_NUMBERS = 22;
const FIRST_GROUP_SIZE = 6;
const SMALL_GROUP_SIZE = 3;
const LAST_GROUP_INDEX = 21;


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-draw-numbers-rychla-6',
  props: {
    numbers: {}
  },
  setup(__props: any) {

const props = __props;

const evenOddRatio = computed(() => {
    const evenOdd = props.numbers.mainGameNumbers[0]?.evenOdd;

    return {
        first: evenOdd?.[0] || 0,
        second: evenOdd?.[1] || 0,
    };
});

const highLowRatio = computed(() => {
    const highLow = props.numbers.mainGameNumbers[0]?.lowHigh;

    return {
        first: highLow?.[0] || 0,
        second: highLow?.[1] || 0,
    };
});

const getBeanColor = (index: number, ratio: { first: number; second: number }) => {
    if (ratio.first === ratio.second) {
        return index < ratio.first ? "blue" : "green";
    }

    if (ratio.first > ratio.second) {
        return index < ratio.first ? "blue" : "grey";
    }
    // ratio.first < ratio.second
    return index >= ratio.first ? "green" : "grey";
};

const getHeadingColor = (first: number, second: number, type: "blue" | "green") => {
    if (first === second) {
        return type;
    }

    if (type === "blue") {
        return first > second ? "blue" : "grey";
    }

    // type === "green"
    return first < second ? "green" : "grey";
};

const groups = computed(() => {
    const mainNumbers = props.numbers.mainGameNumbers[0]?.drawingDrums[0];

    if (!mainNumbers) {
        return [];
    }

    return [
        mainNumbers.slice(0, FIRST_GROUP_SIZE), // First 6 numbers
        ...Array.from({ length: 5 }, (_, i) => mainNumbers.slice(6 + i * SMALL_GROUP_SIZE, 9 + i * SMALL_GROUP_SIZE)), // Groups of 3
        mainNumbers.slice(LAST_GROUP_INDEX), // Remaining number
    ];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (group, groupIndex) => {
        return (_openBlock(), _createElementBlock("ul", {
          key: group.join('-'),
          class: "pp-draw-numbers-rychla-6__group"
        }, [
          (groupIndex < 6)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(groupIndex + 1) + ".", 1))
            : (_openBlock(), _createElementBlock("h3", _hoisted_4, " 22. číslo ")),
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (num) => {
              return (_openBlock(), _createElementBlock("li", {
                key: num,
                class: "pp-draw-numbers-rychla-6__number",
                "data-test": "number"
              }, _toDisplayString(num), 1))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "pp-draw-numbers-rychla-6__group-title" }, "Sudá / Lichá", -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h3", {
            class: _normalizeClass(["pp-draw-numbers-rychla-6__group-title", `pp-draw-numbers-rychla-6__group-title--${getHeadingColor(
                            evenOddRatio.value.first,
                            evenOddRatio.value.second,
                            'blue'
                        )}`])
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "pp-draw-numbers-rychla-6__ratio-label" }, "Sudá", -1)),
            _createElementVNode("span", _hoisted_9, _toDisplayString(evenOddRatio.value.first), 1)
          ], 2),
          _createElementVNode("h3", {
            class: _normalizeClass(["pp-draw-numbers-rychla-6__group-title", `pp-draw-numbers-rychla-6__group-title--${getHeadingColor(
                            evenOddRatio.value.first,
                            evenOddRatio.value.second,
                            'green'
                        )}`])
          }, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "pp-draw-numbers-rychla-6__ratio-label" }, "Lichá", -1)),
            _createElementVNode("span", _hoisted_10, _toDisplayString(evenOddRatio.value.second), 1)
          ], 2)
        ]),
        _createElementVNode("ul", _hoisted_11, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(DRAWN_NUMBERS, (num) => {
            return _createElementVNode("li", {
              key: num,
              class: _normalizeClass(`pp-draw-numbers-rychla-6__ratio-bean pp-draw-numbers-rychla-6__ratio-bean--${getBeanColor(
                            num - 1,
                            evenOddRatio.value
                        )}`)
            }, null, 2)
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "pp-draw-numbers-rychla-6__group-title" }, "Nízká / Vysoká", -1)),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("h3", {
            class: _normalizeClass(["pp-draw-numbers-rychla-6__group-title", `pp-draw-numbers-rychla-6__group-title--${getHeadingColor(
                            highLowRatio.value.first,
                            highLowRatio.value.second,
                            'blue'
                        )}`])
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "pp-draw-numbers-rychla-6__ratio-label" }, "Nízká", -1)),
            _createElementVNode("span", _hoisted_15, _toDisplayString(highLowRatio.value.first), 1)
          ], 2),
          _createElementVNode("h3", {
            class: _normalizeClass(["pp-draw-numbers-rychla-6__group-title", `pp-draw-numbers-rychla-6__group-title--${getHeadingColor(
                            highLowRatio.value.first,
                            highLowRatio.value.second,
                            'green'
                        )}`])
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "pp-draw-numbers-rychla-6__ratio-label" }, "Vysoká", -1)),
            _createElementVNode("span", _hoisted_16, _toDisplayString(highLowRatio.value.second), 1)
          ], 2)
        ]),
        _createElementVNode("ul", _hoisted_17, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(DRAWN_NUMBERS, (index) => {
            return _createElementVNode("li", {
              key: index,
              class: _normalizeClass(`pp-draw-numbers-rychla-6__ratio-bean pp-draw-numbers-rychla-6__ratio-bean--${getBeanColor(
                            index - 1,
                            highLowRatio.value
                        )}`)
            }, null, 2)
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})